import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StaticMsgModule } from '@lib/pipes';
import { MyCarValetRequestSubHeaderComponent } from './my-car-valet-request-sub-header.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [MyCarValetRequestSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule],
  exports: [MyCarValetRequestSubHeaderComponent],
})
export class MyCarValetRequestSubHeaderModule {}
